import React from 'react'
import { useTranslation } from 'react-i18next'


import './dragAndDrop.scss'


function DragAndDrop() {
    const { t } = useTranslation()

    return (
        <div className="container-drag-and-drop">
            <div className="texts-drag-and-drop">
                <h1>{t("rapid_dashboard.drag_and_drop.title")}</h1>
                <p>{t("rapid_dashboard.drag_and_drop.section_text_1")}</p>
                <p>{t("rapid_dashboard.drag_and_drop.section_text_2")}</p>
            </div>
        </div>
    )
}


export default DragAndDrop